/**
 * Cashflow line code → FS schedule/WP code.
 * Click navigation is gated by line.source === 'wp' | 'schedule' (BS/PL audited / derived / bs-fallback do not jump).
 */
export const CF_NAV_FS_CODE: Record<string, string> = {
    // Investing (WP additions / disposal proceed)
    'CF-INV-PPE': 'BS-NCA-PPE',
    'CF-INV-IA': 'BS-NCA-IA',
    'CF-INV-PROCEED': 'PL-OI-GOD',

    // Financing (Dividend payable schedule paid + directors/related party/loans)
    'CF-FIN-DIMH': 'BS-CA-DIMH',
    'CF-FIN-DIR': 'BS-CA-DIR',
    'CF-FIN-DSS': 'BS-CA-DSS',
    'CF-FIN-DRP-A': 'BS-CA-DRP',
    'CF-FIN-DTS': 'BS-CL-DTS',
    'CF-FIN-DTSH': 'BS-CL-DTSH',
    'CF-FIN-DTRC': 'BS-CL-DTRC',
    'CF-FIN-DRP-L': 'BS-CL-DRP',
    'CF-FIN-DTD': 'BS-CL-DTD',
    'CF-FIN-IC': 'BS-EQ-IC',
    'CF-FIN-OFFS': 'BS-EQ-OFFS',
    'CF-FIN-DIV': 'BS-CL-DP',
    'CF-FIN-LOAN': 'BS-CL-BLS',
    'CF-FIN-LEASE': 'BS-CL-OFL',
    'CF-FIN-INT-PAID': 'PL-FC-LI',

    // Analysis (bank WP balances)
    'CF-AN-BANK': 'BS-CA-CASH',
};

/** Sources that mean the CF amount was taken from a working-paper / schedule. */
const SCHEDULE_SOURCES = new Set(['wp', 'schedule']);

/**
 * Resolve navigate FS code for a cashflow line.
 * Only when backend marked source as wp/schedule (not audited BS/PL).
 */
export function resolveCashflowNavFsCode(
    cfCode: string | null | undefined,
    opts?: {
        header?: boolean | null;
        total?: boolean | null;
        source?: string | null;
    },
): string | null {
    if (opts?.header || opts?.total) return null;
    const source = String(opts?.source || '').trim().toLowerCase();
    if (!SCHEDULE_SOURCES.has(source)) return null;
    const key = String(cfCode || '').trim().toUpperCase();
    if (!key) return null;
    return CF_NAV_FS_CODE[key] ?? null;
}
